import { render } from "./AddItems.vue?vue&type=template&id=478d9b8e&scoped=true"
import script from "./AddItems.vue?vue&type=script&lang=js"
export * from "./AddItems.vue?vue&type=script&lang=js"

import "./AddItems.vue?vue&type=style&index=0&id=478d9b8e&lang=scss"
import "./AddItems.vue?vue&type=style&index=1&id=478d9b8e&lang=scss&scoped=true"

import exportComponent from "/app/tmp/downer/V3/v2025.50.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478d9b8e"]])

export default __exports__